import React from "react";
import { TableProps } from "@amzn/awsui-components-react/polaris/table";

import { FullAsinWithAudits } from "../../../from-server/asin-central/model";
import { VALIDATION_COLUMN_DEFINITIONS } from "../asinValidationTable-config";
import { ValidationStatusCell } from "./ValidationStatusCell";

export const DEFAULT_VISIBLE_COLUMNS: readonly string[] = [
  "asin",
  "announceDate",
  "programName",
  "marketplace",
  "description",
  "validationStatus",
  "validationOverallResultHattrick",
  "validationOverallResultLVS",
];

// Hattrick and LVS cells are left to the shared renderer: their
// label lives inside an <a> whose Polaris color wins over any
// surrounding <Box color>, so a text tint would be a visible no-op.
// The pass / fail / no-data signal for those columns comes from the
// icon the shared renderer already prepends.
const CELL_OVERRIDES: Readonly<
  Record<string, (item: FullAsinWithAudits) => React.ReactNode>
> = {
  validationStatus: (item) => (
    <ValidationStatusCell
      value={item.validationStatus as string | null | undefined}
    />
  ),
};

export function overrideCellsFor<T>(
  baseDefs: readonly TableProps.ColumnDefinition<T>[],
  overrides: Readonly<Record<string, (item: T) => React.ReactNode>>
): readonly TableProps.ColumnDefinition<T>[] {
  return baseDefs.map((def) => {
    const override = overrides[def.id ?? ""];
    return override === undefined ? def : { ...def, cell: override };
  });
}

function asinFirst<T>(
  defs: readonly TableProps.ColumnDefinition<T>[]
): readonly TableProps.ColumnDefinition<T>[] {
  const asinIndex = defs.findIndex((def) => def.id === "asin");
  if (asinIndex <= 0) {
    return defs;
  }
  const asin = defs[asinIndex];
  return [asin, ...defs.slice(0, asinIndex), ...defs.slice(asinIndex + 1)];
}

export const DASHBOARD_COLUMN_DEFINITIONS: readonly TableProps.ColumnDefinition<FullAsinWithAudits>[] =
  asinFirst(overrideCellsFor(VALIDATION_COLUMN_DEFINITIONS, CELL_OVERRIDES));
